
import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import NavBar from './components/NavBar';
import Home from './pages/home/Home';
import About from './pages/about/About';
import Services from './pages/services/Services';
import CommercialPestControl from './pages/commercial-pest-control/CommercialPestControl';
import ResidentialPestControl from './pages/residential-pest-control/ResidentialPestControl';
import ConsultancyTraining from './pages/consultancy-training/ConsultancyTraining';
import SanitationServices from './pages/sanitation/SanitationServices';
import FumigationServices from './pages/fumigation-services/FumigationServices';
import BirdControl from './pages/bird-control/BirdControl';
import Blog from './pages/blog/Blog';
import Contact from './pages/contact/Contact';
import Footer from './components/Footer';


const App = () =>  {
  return (
    <BrowserRouter>
      <NavBar/>
        <Routes>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="services" element={<Services />} />
          <Route path="blog" element={<Blog />} />
          <Route path="contact" element={<Contact />} />
          <Route path="commercial-pest-control" element={<CommercialPestControl />} />
          <Route path="residential-pest-control" element={<ResidentialPestControl />} />
          <Route path="consultancy-training" element={<ConsultancyTraining />} />
          <Route path="sanitation-services" element={<SanitationServices />} />
          <Route path="fumigation-services" element={<FumigationServices />} />
          <Route path="bird-control" element={<BirdControl />} />
        </Routes>
      <NavBar/>
      <Footer/>
    </BrowserRouter>
  );
}

export default App;
